<template>
	<div>
		<b-modal v-model="create_modal" title="" hide-footer hide-header ok-only
		@hide="closeModal()" cancel-title="No" ok-title="ACTIVATE NOW">
		<div class="">
			<div class="text-align-center">
					<img  class="" width="48" height="48" src="../../../assets/images/icons/solid/automation_approved.svg"/>
			</div>
			<div class="mt-3">
				<section class="text-align-center automation-group-title-color font-20 font-weight-700 font-gilroy">
					{{params.name}} has been {{edit_create_keys}} 

				</section>

			</div>
			<div class="padding-8 border-4 font-16 font-gilroy background-light-green mt-3 text">
				<section class="text-align-center" v-if="edit_view && automation_rule.is_active == 1">
					The Automation is active
				</section>
				<section class="text-align-start" v-html="rule_sentence" v-else>
					{{rule_sentence}}
				</section>

			</div>
			<div class="mt-3">

				<a v-if="automation_rule.is_active == 0" class="pointer" @click="goBackList()">
					<label class="pointer font-activate-later font-gilroy">SAVE AND ACTIVATE LATER</label>
				</a>
				<button v-if="automation_rule.is_active == 0" @click="createAutomationAndDectivate(1)" class="button float-right">ACTIVATE NOW</button>
				<button v-if="edit_view && automation_rule.is_active == 1" @click="goBackList()" class="button float-right">Back To Automation List</button>
			</div>

		</div>
				
		</b-modal>
	</div>
</template>
<script>
export default {
	props:{
		create_modal:{
			required: true
		},
		automation_rule:{
			required: true
		},
		edit_view:{
			required: true
		},
		rule_sentence:{
			required: false
		},

	},
	data : function(){
		return{
			params: this.automation_rule,
			user_role: this.$store.getters.getRole,
			edit_create_keys: 'created',
		}
	},
	created : function(){
		if(this.edit_view){
			this.edit_create_keys = 'modified'
		}
	
	},
	methods : {
		createAutomationAndDectivate(is_active){
			if(this.user_role ==  'csm'){
				this.params.organization_id = this.$route.params.agency_id
			}
			this.params.is_active = 1
			this.$store.dispatch('editAutomationRuleStatus', this.params).then((res) => {
				this.closeModal()
				this.goBackList()
			}).catch((error) => {
				console.log(error);
			});
		},
		goBackList(){
			this.$emit('backToList')
		},
		closeModal(){
			this.$emit('closeModal')
		}
	}
}
</script>
<style src="../automation.css"></style>


// WEBPACK FOOTER //
// src/components/automation/automationSharedView/createAutomoationModal.vue